import { createActions } from 'redux-actions';

export const { loadJobRules, loadedJobRules, errorJobRules } = createActions(
  'LOAD_JOB_RULES',
  'LOADED_JOB_RULES',
  'ERROR_JOB_RULES',
);
